import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar } from 'antd'
import { getLoggedInUserInfo } from 'utils'
import { userRoleEnums } from 'enums/userRole'
import styles from './style.module.scss'

const mapStateToProps = ({ user, settings: { menuColor } }) => ({ user, menuColor })

const ProfileMenu = ({ dispatch, user, menuColor }) => {
  const logout = (e) => {
    e.preventDefault()
    dispatch({
      type: 'USER_LOGOUT',
    })
  }

  const isAdmin = getLoggedInUserInfo()?.userRole === userRoleEnums?.ADMIN

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>
          <FormattedMessage id="topBar.profileMenu.hello" />, {user.name || 'Anonymous'}
        </strong>
        <div>
          <strong className="mr-1">
            <FormattedMessage id="topBar.profileMenu.billingPlan" />:{' '}
          </strong>
          Professional
        </div>
        <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.role" />:{' '}
          </strong>
          {user.role || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.email" />:{' '}
          </strong>
          {user.email || '—'}
          <br />
          <strong>
            <FormattedMessage id="topBar.profileMenu.phone" />:{' '}
          </strong>
          {user.phone || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      {isAdmin && (
        <Menu.Item>
          <a href="/account-settings">
            <i className={`${styles.menuIcon} fe fe-credit-card`} />
            <FormattedMessage id="topBar.profileMenu.accountSettings" />
          </a>
        </Menu.Item>
      )}
      {isAdmin && <Menu.Divider />}
      <Menu.Item>
        <a href="#" onClick={(e) => e.preventDefault()}>
          <i className={`${styles.menuIcon} fe fe-user`} />
          <FormattedMessage id="topBar.profileMenu.editProfile" />
        </a>
      </Menu.Item>
      {isAdmin && (
        <>
          <Menu.Divider />
          <Menu.Item>
            <a href="#" onClick={(e) => e.preventDefault()}>
              <i className={`${styles.menuIcon} fe fe-user`} />
              <FormattedMessage id="topBar.profileMenu.companyProfile" />
            </a>
          </Menu.Item>
        </>
      )}
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={logout}>
          <i className={`${styles.menuIcon} fe fe-log-out`} />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown}>
        <Avatar
          className={menuColor === 'dark' ? styles.avatarDark : styles.avatar}
          shape="square"
          size="large"
          icon={<UserOutlined />}
        />
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
